(function () {
    function addAosAttributes() {
        let animatedElems = document.querySelectorAll('.fade-right, .fade-left, .fade-columns, .fade-in');

        if( animatedElems ) {
            animatedElems.forEach(function(item, index) {

                if(item.classList.contains('fade-right')) {
                    item.setAttribute('data-aos', 'fade-right');
                } else if (item.classList.contains('fade-in')) {
                    item.setAttribute('data-aos', 'fade-in');
                } else if(item.classList.contains('fade-left')) {
                    item.setAttribute('data-aos', 'fade-left');
                } else if(item.classList.contains('fade-columns')) {
                    let columns = item.querySelectorAll('.wp-block-column');

                    if(columns.length) {
                        columns.forEach(function(col, index) {
                            col.setAttribute('data-aos', 'fade-up');
                            col.setAttribute('data-aos-delay', 150 * index);
                        });
                    }
                }

                if( animatedElems.length == (index + 1) ) {
                    setTimeout(function() {
                        AOS.init({
                          throttleDelay: 250,
                          once: false,
                          duration: 900,
                          offset: 100,
                          once: true,
                          duration: 700,
                          easing: 'ease-out',
                          throttleDelay: 200,
                        //   anchorPlacement: 'bottom-top',
                          offset: 100
                        });
                    }, 500);
                }
            });
        }
    }


    window.addEventListener('load', function () {
        addAosAttributes();
    });
})()


//////////////////
// WEBPACK FOOTER
// ./js/modules/animations.js
// module id = 15
// module chunks = 0